import { render, staticRenderFns } from "./update-notify.vue?vue&type=template&id=f4f8ebc0&scoped=true"
import script from "./update-notify.vue?vue&type=script&lang=js"
export * from "./update-notify.vue?vue&type=script&lang=js"
import style0 from "./update-notify.vue?vue&type=style&index=0&id=f4f8ebc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f8ebc0",
  null
  
)

export default component.exports